export function convertToMillions(value: number, decimal: number = 0): string {
  if (!value) return '0';
  const abs = Math.abs(value);
  const fmt = (scaled: number, suffix: string) => {
    const fixed = scaled.toFixed(decimal);
    const [int, dec] = fixed.split('.');
    const intStr = parseInt(int).toLocaleString('es-CO');
    return dec ? `${intStr},${dec}${suffix}` : `${intStr}${suffix}`;
  };
  if (abs >= 1_000_000) return fmt(value / 1_000_000, 'M');
  if (abs >= 1_000)     return fmt(value / 1_000, 'K');
  return value.toLocaleString('es-CO');
}
